import { Tab } from "@headlessui/react";

const ReportTabs = ({ items }) => {
  const classNames = (...classes) => {
    return classes.filter(Boolean).join(" ");
  };

  return (
    <div className="w-full px-0 py-3">
      <Tab.Group>
        <Tab.List className="flex p-1 space-x-1 bg-white rounded border">
          {items.map((item, key) => (
            <Tab
              key={key}
              className={({ selected }) =>
                classNames(
                  "w-full py-2.5 text-sm leading-5 focus:outline-none hover:text-gray-500",
                  selected ? "text-blue-400" : "text-gray-400"
                )
              }
            >
              {item.title}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels>
          {items.map((item, key) => (
            <Tab.Panel key={key} className="mt-3">
              {item.content}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default ReportTabs;
